import { gql } from "@apollo/client";

export const getPublishedOffers = gql`
  query PublishedOffers($offerStatus: OfferStatus!, $limit: Int, $offset: Int) {
  publishedOffersCount(
      OfferStatus: $offerStatus
      limit: $limit
      offset: $offset
    )
    publishedOffers(OfferStatus: $offerStatus, limit: $limit, offset: $offset) {
      offer_published_id
      published_status
      employeesemployee_id
      updated_by
      time_of_expiry
      created_at
      updated_at
      employee {
        employee_id
        employee_first_name
        employee_email
        emp_abbrv
        employee_last_name
        employee_phonenumber
      }
      offer {
        offer_id
      }
      status
    }
  }
`;

export const getPublishedOffersCount = gql`
  query Query($offerStatus: OfferStatus!, $limit: Int, $offset: Int) {
    publishedOffersCount(
      OfferStatus: $offerStatus
      limit: $limit
      offset: $offset
    )
  }
`;

export const getOfferPublishedParticipants = gql`
  query GetOfferPublishedParticipants($offerId: ID!) {
    getOfferPublishedParticipants(offer_id: $offerId) {
      offer_published_participant_id
      reinsurer {
        reinsurer_id
        re_company_website
        re_company_name
        re_company_email
        re_abbrv
      }
      reinsurer_representative {
        rep_first_name
        rep_last_name
        rep_primary_phonenumber
        rep_secondary_phonenumber
        rep_email
        reinsurer_representative_id
        position
        delete_status
      }
      offer_participant_percentage
      transaction_thread
      participation_status
      offer {
        offer_id
        facultative_offer
      }
        unread_messages {
      id
      offer {
        offer_id
      }
      status
      receiver_type
      offer_published_participant_id
    }
    }
  }
`;
